import { isValidEmailAddress, fadeOutNotifications } from '../functions';

$(document).ready(function() {

	const cookiesSettings = {
        isLoading: false,
        social: 1,
        advertisement: 1,
        web_analytics: 1,
        init() {
            $(document).on('click', '.cookies-settings-modal-btn', this, this.openModal);
            $(document).on('click', '.cookies-settings-close-btn', this, this.closeModal);
            $(document).on('click', '.btn_cookies', this, this.acceptAllCookies);
            $(document).on('change', '#cookies_social', this, this.socialAction);
            $(document).on('change', '#cookies_advertisement', this, this.advertisementAction);
            $(document).on('change', '#cookies_web_analytics', this, this.webAnalytics);
            $(document).on('click', '#save-cookies-settings-btn', this, this.acceptCookies);
        },
		socialAction(event) {
			const _this = event.data;

			if ($(this).is(':checked')) {
				_this.social = 1;
			} else {
				_this.social = 0;
			}
		},
		advertisementAction(event) {
			const _this = event.data;

			if ($(this).is(':checked')) {
				_this.advertisement = 1;
			} else {
				_this.advertisement = 0;
			}
		},
		webAnalytics(event) {
			const _this = event.data;

			if ($(this).is(':checked')) {
				_this.web_analytics = 1;
			} else {
				_this.web_analytics = 0;
			}
		},
		openModal(event) {
			const _this = event.data;

			$("#cookies-settings-modal").modal('show');
		},
		closeModal(event) {
			const _this = event.data;

			$("#cookies-settings-modal").modal('hide');
		},
		acceptCookies(event) {
			const _this = event.data;

			var values = 'social=' + _this.social;
			values += '&advertisement=' + _this.advertisement;
			values += '&web_analytics=' + _this.web_analytics;
	        $.ajax({
	            type: "GET",
	            url: baseURL + "/accept-cookies-policy",
	            data: values,
	            success: function(html) {
	                $('.box_cookies').hide();
					$("#cookies-settings-modal").modal('hide');
	            }
	        });
		},
		acceptAllCookies(event) {
			const _this = event.data;

			var values = 'all=1';
	        $.ajax({
	            type: "GET",
	            url: baseURL + "/accept-cookies-policy",
	            data: values,
	            success: function(html) {
	                $('.box_cookies').hide();
					$("#cookies-settings-modal").modal('hide');
	            }
	        });
		},
    };

    cookiesSettings.init();
});



// WEBPACK FOOTER //
// ./resources/js/modules/cookies.js